<button
	*ngIf="showFeedbackButton"
	mat-fab
	color="primary"
	class="feedback-button"
	(click)="openFeedbackDialog()"
	matTooltip="Submit Feedback"
>
	<mat-icon>feedback</mat-icon>
</button>
